import { Destino } from "./destino";

export class Tarifa {
  idCliente:number;
  idPromoActivacion: number;

  destinoLatitud: number;
  destinoLongitud: number;
  dirDestino: string;
  dirOrigen: string;
  idEmpresa: number;
  idTipoPago: number;
  origenLatitud: number;
  origenLongitud: number;
  tipoServicio: number;
  modoReserva: number;
  lstDestinos: Destino[];
  primerDestino: boolean;
  constructor() {

  }
}

export class TarifaMultiDestinoResponse {
  monto: number;
  distancia: number;
  id: string;
  constructor() {

  }
}

export class TarifaMultiDestino {
  latLngOrigen: google.maps.LatLng;
  latLngDestino: google.maps.LatLng;
  id: string;
}
